import React from "react";
import { useInView } from "react-intersection-observer";
import s from "./index.module.scss";

const StickyBlock = ({ children, zIndex }) => {
	const [containerRef, inView] = useInView({
		threshold: 0
	});

	return (
		<div ref={containerRef} className={s.container}>
			<div style={{ zIndex: zIndex }} className={s.item}>
				{inView && children}
			</div>
		</div>
	);
};

export default StickyBlock;
